import Cookies from "js-cookie";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import moment from "moment";

import { EmployeesMonthlyReportDatePicker } from "./_components/date-picker";
import {
  getAllEmployeesQueryOptions,
  getAttendanceOfAllEmployeesForAdminQueryOptions,
} from "@/config/queries/query-options";
import { useDateRangeStore } from "./_components/date-picker/use-date-store";
import { DataTable } from "./_components/report-table/data-table";
import { columns } from "./_components/report-table/columns";

function daysBetween(date1: string | Date, date2: string | Date): number {
  const startDate = moment(date1);
  const endDate = moment(date2);

  // Calculate the difference in days
  const differenceInDays = endDate.diff(startDate, "days") + 1;

  return differenceInDays;
}

function isAfter915AM(dateTime: Date): boolean {
  // Create a new Date object with the same date as dateTime, but set time to 9:15 AM
  const targetTime = new Date(dateTime);
  targetTime.setHours(9, 15, 0, 0); // Set hours, minutes, seconds, milliseconds

  // Check if the given dateTime is after 9:15 AM
  return dateTime > targetTime;
}

const EmployeesMonthlyReport = () => {
  const user = Cookies.get("key") as string;

  const { data, isPending, isFetching } = useQuery(
    getAllEmployeesQueryOptions(user)
  );

  const employeesData = useMemo(() => {
    if (isPending || isFetching) {
      return [];
    }

    if (data === undefined || data?.employees === undefined) {
      return [];
    }

    const tempResult = data?.employees?.filter((item) => !item.blocked);

    const result = tempResult?.map((emp) => {
      return {
        id: emp?._id,
        name: emp?.name,
      };
    });

    return result;
  }, [data, isPending, isFetching]);

  const { dateRange } = useDateRangeStore();

  // const { filter, setFilter } = useStatusFilter();

  const startdate = dateRange?.from as Date;
  const enddate = dateRange?.to as Date;

  const {
    data: employeesAttendancesData,
    isPending: isAttendancePending,
    isFetching: isAttendanceFetching,
  } = useQuery(
    getAttendanceOfAllEmployeesForAdminQueryOptions(user, startdate, enddate)
  );

  console.log("employees Attendance Data", employeesAttendancesData);

  const reportData = useMemo(() => {
    if (isAttendancePending) {
      return employeesData;
    }

    if (
      employeesAttendancesData === undefined ||
      employeesAttendancesData?.attendance === undefined
    ) {
      return employeesData;
    }

    let result = employeesData?.map((emp) => {
      return {
        ...emp,
        Present: 0,
        "Half-day": 0,
        "Paid Leave": 0,
        "On Leave": 0,
        "Not Counting": 0,
        Absent: 0,
        Holiday: 0,
        "Total Working Days": 0,
        TotalDays: daysBetween(startdate, enddate),
        LateDays: 0,
      };
    });

    const attendances = employeesAttendancesData?.attendance;

    for (const attendance of attendances) {
      const empId = attendance?.employee?._id;
      const attStatus = attendance?.status;
      const findEmp = result?.find((item) => item.id === empId);

      const checkin = attendance?.checkin?.[0];
      console.log("CHECKIN", checkin);

      if (findEmp && checkin) {
        const checkinTime = new Date(checkin?.createdAt);
        console.log("NOW", new Date());
        console.log("Checkin Time", checkinTime);
        const isLate = isAfter915AM(checkinTime);
        console.log("IS Late", isLate);
        if (isLate) {
          findEmp["LateDays"] += 1;
        }
      }

      if (findEmp && attStatus === "Present") {
        findEmp[attStatus] += 1;
        findEmp["Total Working Days"] += 1;
      } else if (
        findEmp &&
        attStatus === "Half-day" &&
        typeof findEmp[attStatus] === "number"
      ) {
        findEmp[attStatus] += 1;
        findEmp["Total Working Days"] += 0.5;
        findEmp["Absent"] += 0.5;
      }
      // @ts-ignore
      else if (findEmp && typeof findEmp[attStatus] === "number") {
        // @ts-ignore
        findEmp[attStatus] += 1;
      }
    }

    return result;
  }, [
    isAttendanceFetching,
    isAttendancePending,
    // employeesAttendancesData,
    // employeesData,
    startdate,
    enddate,
  ]);

  return (
    <div className="p-5 h-[calc(100%-56px)]">
      <div className="flex items-center justify-between">
        <h3 className="text-2xl font-medium">Employees Monthly Report</h3>

        <div className="flex items-center gap-2">
          <EmployeesMonthlyReportDatePicker />
        </div>
      </div>

      <div className="mt-5 mb-10 pb-10">
        {/* @ts-ignore */}
        <DataTable data={reportData} columns={columns} />
      </div>
    </div>
  );
};

export default EmployeesMonthlyReport;
